<template>
  <div class="contaier">
    <page-header></page-header>
    <div class="events-hq">
      <div class="events-box">
        <div class="hq-title1">{{ $t('public.newsTitle') }}</div>
        <div class="box">
          <div
            :key="item.id"
            class="about-item "
            v-for="item in newsList"
            @click="goNewPage(item.id)">
            <!-- <img class="car-img" :src="item.img" /> -->
            <el-image fit="cover" :src="item.img" class="car-img"> </el-image>
            <div class="text">{{ langShow(item.title) }}</div>
            <div class="b-box">
              <div class="date">{{ item.createTime }}</div>
              <div class="btn">
                {{ $t('public.learnMore') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ------------------------ 内 ** ------------------------ -->
    <footer-page></footer-page>
  </div>
</template>

<script>
import { activityTime } from '@/utils/utils'
import { imgBase } from '@/assets/js/static'
import { langMixins } from '@/mixins/langMixins'
import { newsListApi } from '@/Api/requestApi'
import PageHeader from '@/components/PageHeader.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'NewsView',
  mixins: [langMixins],
  components: {
    PageHeader,
    FooterPage,
  },
  data() {
    return {
      newsList: [],
    }
  },
  mounted() {
    this.getNewsListFn()
    this.$nextTick(() => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.langFn('/newsList')
    })
  },
  methods: {
    langShow(p) {
      if (!p) {
        return ''
      }
      return p[this.$i18n.locale]
    },
    goNewPage(id) {
      this.$router
        .push({
          path: '/news',
          query: { id, lang: this.$i18n.locale },
        })
        .catch(() => {})
    },
    async getNewsListFn() {
      const {
        data: { code, data },
        // } = await newsListApi({ state: '' })
      } = await newsListApi({ state: 1 })
      if (code == 200) {
        let newsList_ = []
        for (let i = 0; i < data.length; i++) {
          let {
            id,
            title,
            titleEn,
            content,
            contentEn,
            titleImage,
            createTime,
          } = data[i]
          newsList_.push({
            id,
            title: { zh: title, en: titleEn },
            img: `${imgBase}${titleImage}?iopcmd=thumbnail&type=4&width=600&quality=60`,
            createTime: activityTime(createTime),
            content: { zh: content, en: contentEn },
          })
        }
        this.newsList = newsList_
        // this.newsList = newsList_.filter(e => e.id > 3)
        // console.log('newsList_ :>> ', newsList_)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.hq-title1 {
  line-height: 90px;
  // padding-top: 60px;
  // padding-bottom: 40px;
  font-size: 26px;
  text-align: center;
}
.contaier {
  // background-color: #f1f1f1;
}
.events-hq {
  min-height: calc(100vh - 240px);
  // padding: 80px 0;
  padding-top: 114px;
  // padding-bottom: 60px;
  .events-box {
    max-width: 1770px;
    margin: 0 auto;
  }
  .box {
    padding: 40px 20px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .about-item {
      overflow: hidden;
      width: calc((100% - 60px) / 3);
      margin-bottom: 40px;
      // background-color: #fff;
      .car-img {
        width: 100%;
        aspect-ratio: 16 / 10;
        transition: all 0.6s;
      }
      .car-img:hover {
        transform: scale3d(1.05, 1.05, 1.05);
      }
      .text {
        height: 48px;
        margin: 10px 0;
        // padding-bottom: 5%;
        font-weight: 700;
        // border-bottom: solid 1px #222;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        cursor: pointer;
        color: #333;
      }
      .b-box {
        // padding-top: 30px;
        padding-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .date {
          font-size: 14px;
        }
        .btn {
          width: 100px;
          line-height: 32px;
          font-size: 12px;
          text-align: center;
          border: solid 2px #333;
          cursor: pointer;
          z-index: 9999;
          color: #333;
        }
        .btn:hover {
          background-color: rgba(255, 255, 255, 1);
          color: #222;
        }
      }
    }

    .about-item:nth-child(n + 2) {
      margin-left: 30px;
    }
    .about-item:nth-child(3n + 1) {
      margin-left: 0;
    }
  }
}
@media (max-width: 992px) {
  .hq-title1 {
    font-size: 26px;
  }
  // ------------------------ 红旗活动**start ------------------------
  .events-hq {
    // padding: 60px 0;
    .events-box {
    }
    .box {
      // padding-top: 40px;
      // padding: 40px 20px 0;
      .about-item {
        width: calc((100% - 30px) / 3);
        margin-bottom: 30px;
        .car-img {
          transition: all 0.6s;
        }
        .car-img:hover {
          transform: scale3d(1, 1, 1);
        }
        .text {
          height: 52px;
          line-height: 1.5;
        }
        .b-box {
          // padding-top: 10px;
          .date {
            font-size: 12px;
          }
          .btn {
            width: 100px;
            line-height: 32px;
            font-size: 12px;
          }
          .btn:hover {
          }
        }
      }
      .about-item:nth-child(n + 2) {
        margin-left: 15px !important;
      }

      .about-item:nth-child(3n + 1) {
        margin-left: 0 !important;
      }
    }
  }
}
@media (max-width: 768px) {
  .hq-title1 {
    font-size: 24px;
  }
  // ------------------------ 红旗活动**start ------------------------
  .events-hq {
    // padding: 60px 0;
    .events-box {
    }
    .box {
      // padding: 40px 20px 0;
      .about-item {
        width: calc((100% - 20px) / 2);
        margin-bottom: 20px;
        .car-img {
          transition: all 0.6s;
        }
        .car-img:hover {
          transform: scale3d(1, 1, 1);
        }
        .text {
          line-height: 1.5;
          height: 52px;
        }
        .b-box {
          // padding-top: 20px;
          .date {
            font-size: 12px;
          }
          .btn {
            width: 100px;
            line-height: 32px;
            font-size: 12px;
          }
          .btn:hover {
          }
        }
      }
      .about-item:nth-child(n + 2) {
        margin-left: 20px !important;
      }

      .about-item:nth-child(2n + 1) {
        margin-left: 0 !important;
      }
    }
  }
}
@media (max-width: 490px) {
  .hq-title1 {
    font-size: 24px;
  }
  // ------------------------ 红旗活动**start ------------------------
  .events-hq {
    // padding: 60px 0;
    .events-box {
    }
    .box {
      // padding: 40px 20px 0;
      .about-item {
        width: 100%;
        margin-bottom: 20px;
        // margin-left: 0px !important;
        .car-img {
          // transition: all 0.6s;
        }

        .text {
          // line-height: 1.5;
          // height: 52px;
        }
        .b-box {
          // padding-top: 20px;
          .date {
            font-size: 12px;
          }
          .btn {
            // width: 100px;
            line-height: 32px;
            font-size: 10px;
            // border: solid 1px #333;
          }
          .btn:hover {
          }
        }
      }
      .about-item:nth-child(n) {
        margin-left: 0 !important;
      }
    }
  }
}
</style>
